<template>
  <div v-if="reportInfo">
    <h3 class="section-title">취약점 신고 접수 안내</h3>
    <div class="notice-box">
      <div class="notice-box__text">
        1. 아래와 같은 경우는 평가대상에서 제외하며 별도의 조치 없이 내부 종결될
        수 있습니다.<br />
        <ul class="notice-box__list">
          <li>
            - 허위 또는 과장되거나 불분명하여 취약점을 파악할 수 없는 경우,
            가능성만 제시되어 완벽하지 않은 취약점
          </li>
          <li>
            - 취약점으로 인해 발생할 수 있는 피해가 매우 미미하거나, 공격자
            측면에서 신고된 취약점을 굳이 악용에 사용할 필요가 없을 정도로
            파급도가 매우 낮은 취약점
          </li>
          <li>
            - 개념증명코드(Proof Of Concept Code, PoC Code) 제공이 없는 신고
          </li>
        </ul>
      </div>
      <p class="notice-box__text">
        2. 제조사가 검색되지 않을 시, 회사명을 '소프트웨어 없음' 선택 후 수기
        입력해 주시기 바랍니다.<br />
      </p>
      <div class="notice-box__text">
        3. 취약점 신고 유형 구분<br />
        <ul class="notice-box__list">
          <li>
            - <strong>신고포상제</strong> : 취약점 평가 결과에 따라 포상금 지급
            및 취약점 조치 수행
          </li>
          <li>
            - <strong>일반신고 </strong>: 공익 목적으로 신고된 취약점에 대해
            취약점 조치 수행(포상금 미지급)
            <ul class="notice-box__list">
              <li>
                - 신고포상제 평가 제외사항에 해당되는 취약점은 일반신고 접수
                필요
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="notice-box__text">
        4. 취약점 신고내용 및 첨부파일(보고서 표지, 본문 등)에 개인정보가
        포함되지 않도록 작성해 주시기 바랍니다.<br />
        <ul class="notice-box__list">
          <li>
            - 캡처된 화면의 파라미터값에 이름, 이메일, 전화번호, 소속 등이
            포함되는 경우에도 제조사·개발사·고객사에 개인정보가 노출될 우려가
            있습니다.
          </li>
        </ul>
      </div>
      <div class="notice-box__text">
        5. 신고서에 작성한 내용이 사실과 다르거나 KISA를 제외한 제3자에게
        취약점을 공개한 경우, 비밀유지 의무 등을 위반한 사실이 밝혀진 경우
        다음과 같은 불이익이 있을 수 있습니다.<br />
        <ul class="notice-box__list">
          <li>- 사실 확인일로부터 1년 동안 평가 및 포상대상에서 제외</li>
          <li>
            - 해당 취약점으로 이미 포상받은 경우 포상 취소 및 지급 포상금 전액
            환수, 법적대응
          </li>
        </ul>
      </div>
    </div>
    <table class="board-write type-block--mobile">
      <tbody>
        <tr>
          <th scope="row">
            포상 유형
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="rewardNm" class="sr-only">포상 유형</label>
            <div
              class="layout-flex-row"
              v-if="edit && !modReportInfo?.hasDistributed"
            >
              <select
                name="rewardNm"
                id="rewardNm"
                v-model="reportInfo.rewardNm"
                @change="handleChange('reward')"
              >
                <option value="">선택하세요</option>
                <option
                  v-for="item in rewardNmCodes"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.rewardNm }}
                </option>
              </select>
              <select
                name="rewardSubNm"
                id="rewardSubNm"
                v-model="reportInfo.rewardSubNm"
                @change="rewardSubNmChange"
              >
                <option value="">선택하세요</option>
                <option
                  v-for="item in rewardSubNmCodes"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.subNm }}
                </option>
              </select>
            </div>
            <div v-else>
              <span
                >{{ reportInfo.rewardNmStr || "-" }} /
                {{ reportInfo.rewardSubNmStr || "-" }}</span
              >
            </div>
            <div class="u-color-red" v-if="showRewardExpired">
              현재 포상 유형 ({{ reportInfo.rewardNmStr }} /
              {{ reportInfo.rewardSubNmStr }})는 만료된 포상 유형 입니다.
            </div>
          </td>
        </tr>
        <!-- 취약점 제목 -->
        <tr>
          <th scope="row">
            취약점 제목
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="vulTitle" class="sr-only">취약점 제목</label>
            <input
              v-if="edit"
              type="text"
              id="vulTitle"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulTitle"
            />
            <span v-else> {{ reportInfo.vulTitle || "-" }}</span>
          </td>
        </tr>
        <!-- 취약점 요약 -->
        <tr>
          <th scope="row">
            취약점 요약
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="vulSummary" class="sr-only">취약점 요약</label>
            <input
              v-if="edit"
              type="text"
              id="vulSummary"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulSummary"
            />
            <span v-else> {{ reportInfo.vulSummary || "-" }}</span>
          </td>
        </tr>
        <!-- 제조사 -->
        <tr>
          <th scope="row">
            제조사 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="makrName" class="sr-only">제조사</label>
            <input
              v-if="edit"
              type="text"
              id="makrName"
              class="board-write__input clickable-row"
              @click="isModal = true"
              v-model="reportInfo.makrName"
              placeholder="제조사를 입력하시려면 클릭해주세요."
              readonly
            />
            <span v-else> {{ reportInfo.makrName || "-" }}</span>
          </td>
        </tr>
        <!-- 소프트웨어명 -->
        <tr>
          <th scope="row">
            소프트웨어
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="swNmText" class="sr-only">소프트웨어</label>
            <input
              v-if="edit"
              type="text"
              id="swNmText"
              placeholder="소프트웨어를 입력하시려면 클릭해주세요."
              class="board-write__input clickable-row"
              v-model="reportInfo.swNmText"
              @click="isModal = true"
              readonly
            />
            <span v-else> {{ reportInfo.swNmText || "-" }}</span>
          </td>
        </tr>
        <!-- 제조사,소프트웨어 없는경우 수기입력 -->
        <tr
          v-if="
            reportInfo.makrName === '없음' || reportInfo.swNmText === '없음'
          "
        >
          <th scope="row">
            제조사 및 소프트웨어(수기 입력)<span class="u-color-red"> *</span>
          </th>
          <td>
            <label for="forcedEntryMakrName" class="sr-only"
              >제조사 및 소프트웨어(수기 입력)</label
            >
            <input
              v-if="edit"
              type="text"
              id="forcedEntryMakrName"
              placeholder="제조사 및 소프트웨어를 입력해주세요"
              class="board-write__input"
              v-model="reportInfo.forcedEntryMakrName"
            />
            <span v-else> {{ reportInfo.forcedEntryMakrName || "-" }}</span>
          </td>
        </tr>
        <!-- 버전 -->
        <tr>
          <th scope="row">
            버전 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="ver" class="sr-only">버전</label>
            <input
              v-if="edit"
              type="text"
              id="ver"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.ver"
            />
            <span v-else> {{ reportInfo.ver || "-" }}</span>
          </td>
        </tr>
        <!-- 소프트웨어 유형 -->
        <tr>
          <th scope="row">
            소프트웨어 유형
            <span class="u-color-red"> *</span>
          </th>
          <td>
            <div class="layout-flex-row">
              <label for="makrSeCd" class="sr-only">소프트웨어 유형 1</label>
              <select
                v-if="edit"
                id="makrSeCd"
                name="makrSeCd"
                v-model="reportInfo.makrSeCd"
                @change="handleChange('makrSe', 1)"
                :disabled="modReportInfo?.hasDistributed || !edit"
              >
                <option value="">선택하세요</option>
                <option
                  v-for="item in makrSeCdCodes"
                  :key="item.cd"
                  :value="item.cd"
                >
                  {{ item.cdNm }}
                </option>
              </select>
              <label for="makrSeCdMid" class="sr-only">소프트웨어 유형 2</label>
              <select
                v-if="edit"
                id="makrSeCdMid"
                name="makrSeCdMid"
                v-model="reportInfo.makrSeCdMid"
                @change="handleChange('makrSe', 2)"
              >
                <option value="">선택하세요</option>
                <option
                  v-for="item in makrSeCdMidCodes"
                  :key="item.cd"
                  :value="item.cd"
                >
                  {{ item.cdNm }}
                </option>
              </select>
              <label for="makrSeCdSml" class="sr-only">소프트웨어 유형 3</label>
              <select
                v-if="edit"
                id="makrSeCdSml"
                name="makrSeCdSml"
                v-model="reportInfo.makrSeCdSml"
              >
                <option value="">선택하세요</option>
                <option
                  v-for="item in makrSeCdSmlCodes"
                  :key="item.cd"
                  :value="item.cd"
                >
                  {{ item.cdNm }}
                </option>
              </select>
              <span v-if="!edit">
                {{ makrSeCdNmChange(reportInfo) }}
              </span>
            </div>
          </td>
        </tr>
        <!-- 공격 유형 -->
        <tr>
          <th scope="row">공격 유형</th>
          <td>
            <label for="vulAttack" class="sr-only">공격 유형</label>
            <select
              v-if="edit"
              name="vulAttack"
              id="vulAttack"
              v-model="reportInfo.vulAttack"
              @change="vulAttackChange(reportInfo.vulAttack)"
            >
              <option value="">선택하세요</option>
              <option
                v-for="item in vulAttackTypeCodes"
                :key="item.cd"
                :value="item.cd"
              >
                {{ item.cdNm }}
              </option>
            </select>
            <span v-else>
              {{ vulAttackChange(reportInfo.vulAttack) || "-" }}</span
            >
            <div
              v-if="edit && reportInfo.vulAttack === 'ATTACK_TY_CD_ETC'"
              style="margin-top: 8px"
            >
              <input
                type="text"
                v-model="reportInfo.attackDesc"
                placeholder="직접 입력"
                class="board-write__input"
              />
            </div>
            <div v-else class="u-color-red" style="margin-top: 8px">
              <span>{{ reportInfo.attackDesc }}</span>
            </div>
          </td>
        </tr>
        <!-- 영향 -->
        <tr>
          <th scope="row">영향</th>
          <td>
            <label for="vulEff" class="sr-only">영향</label>
            <select
              v-if="edit"
              name="vulEff"
              id="vulEff"
              v-model="reportInfo.vulEff"
              @change="vulEffectChange(reportInfo.vulEff)"
            >
              <option value="">선택하세요</option>
              <option
                v-for="item in vulEffectCodes"
                :key="item.cd"
                :value="item.cd"
              >
                {{ item.cdNm }}
              </option>
            </select>
            <span v-else> {{ vulEffectChange(reportInfo.vulEff) || "-" }}</span>
            <div
              v-if="edit && reportInfo.vulEff === 'EFFECT_CD_ETC'"
              style="margin-top: 8px"
            >
              <input
                type="text"
                v-model="reportInfo.effectDesc"
                placeholder="직접 입력"
                class="board-write__input"
              />
            </div>
            <div v-else class="u-color-red" style="margin-top: 8px">
              <span>{{ reportInfo.effectDesc }}</span>
            </div>
          </td>
        </tr>
        <!-- 취약한 파일명 -->
        <tr v-show="showVulFile">
          <th scope="row">취약한 파일명</th>
          <td>
            <label for="vulFile" class="sr-only">취약한 파일명</label>
            <input
              v-if="edit"
              type="text"
              id="vulFile"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulFile"
            />
            <span v-else> {{ reportInfo.vulFile || "-" }}</span>
          </td>
        </tr>
        <!-- 취약한 함수명 -->
        <tr v-show="showVulMethod">
          <th scope="row">취약한 함수명</th>
          <td>
            <label for="vulMethod" class="sr-only">취약한 함수명</label>
            <input
              v-if="edit"
              type="text"
              id="vulMethod"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulMethod"
            />
            <span v-else> {{ reportInfo.vulMethod || "-" }}</span>
          </td>
        </tr>
        <!-- 취약한 URL -->
        <tr v-show="showVulUrl">
          <th scope="row">취약한 URL</th>
          <td>
            <label for="vulUrl" class="sr-only">취약한 URL</label>
            <input
              v-if="edit"
              type="text"
              id="vulUrl"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulUrl"
            />
            <span v-else> {{ reportInfo.vulUrl || "-" }}</span>
          </td>
        </tr>
        <!-- 취약한 파라미터 -->
        <tr v-show="showVulParam">
          <th scope="row">취약한 파라미터</th>
          <td>
            <label for="vulParam" class="sr-only">취약한 파라미터</label>
            <input
              v-if="edit"
              type="text"
              id="vulParam"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulParam"
            />
            <span v-else> {{ reportInfo.vulParam || "-" }}</span>
          </td>
        </tr>
        <!-- 취약점 발생환경 -->
        <tr>
          <th scope="row">
            취약점 발생환경
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 발생환경</label>
            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulEnvironment"
              :id="'vulEnvironment'"
              :key="`vulEnvironment-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulEnvironment"
              v-dompurify-html="reportInfo.vulEnvironmentHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 발견방법 -->
        <tr>
          <th scope="row">
            취약점 발견방법
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 발견방법</label>

            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulDetection"
              :id="'vulDetection'"
              :key="`vulDetection-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulDetection"
              v-dompurify-html="reportInfo.vulDetectionHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 발생원인 -->
        <tr>
          <th scope="row">
            취약점 발생원인
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 발생원인</label>

            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulCause"
              :id="'vulCause'"
              :key="`vulCause-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulCause"
              v-dompurify-html="reportInfo.vulCauseHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 증명/검증 -->
        <tr>
          <th scope="row">
            취약점 증명/검증
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 증명/검증</label>
            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulVerify"
              :id="'vulVerify'"
              :key="`vulVerify-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulVerify"
              v-dompurify-html="reportInfo.vulVerifyHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 악용 시나리오 -->
        <tr>
          <th scope="row">
            취약점 악용 시나리오
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 악용 시나리오</label>
            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulScript"
              :id="'vulScript'"
              :key="`vulScript-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulScript"
              v-dompurify-html="reportInfo.vulScriptHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 조치방안 -->
        <tr>
          <th scope="row">
            취약점 조치방안
            <span class="u-color-red"> *</span>
          </th>
          <td class="editor-field">
            <label class="sr-only">취약점 조치방안</label>

            <StacksEditor
              v-if="edit"
              v-model="reportInfo.vulAction"
              :id="'vulAction'"
              :key="`vulAction-${editorKey}`"
              :system="'report'"
              @htmlchanged="onHtmlChanged"
            />
            <span
              v-else
              id="vulAction"
              v-dompurify-html="reportInfo.vulActionHtml || '-'"
            ></span>
          </td>
        </tr>
        <!-- 취약점 기타 -->
        <tr>
          <th scope="row">취약점 기타</th>
          <td>
            <label class="sr-only">취약점 기타</label>
            <input
              v-if="edit"
              type="text"
              id="vulEtc"
              placeholder=""
              class="board-write__input"
              v-model="reportInfo.vulEtc"
            />
            <span v-else> {{ reportInfo.vulEtc || "-" }}</span>
          </td>
        </tr>
        <!-- 첨부파일 -->
        <tr v-if="!edit">
          <th scope="row">첨부파일</th>
          <td>
            <div class="readonly-value">
              <template v-if="reportInfo && reportInfo.attachNm">
                <a class="link-primary" @click.prevent="downloadAttach()">
                  {{ reportInfo.attachNm }}
                </a>
              </template>
              <template v-else>첨부파일 없음</template>
            </div>
          </td>
        </tr>
        <tr v-if="edit">
          <th scope="row">첨부파일 등록</th>
          <td>
            <FileUpload
              :max-size="30"
              :allow-ext="allowExt"
              @add="handleFileAdd"
              :uploadFile="uploadFile"
            ></FileUpload>
          </td>
        </tr>
      </tbody>
    </table>

    <Modal
      :visible="isModal"
      pop_tit="제조사 및 소프트웨어 검색"
      popSizeClass="popup__container--l"
      @close="closeModal"
    >
      <template #pop_content>
        <MakrSearchModal v-model="forcedEntryMakrName" @add="addMakrInfo" />
      </template>
      <template #pop_buttons>
        <button type="button" class="btn btn--m btn--blue" @click="addMakrName">
          등록
        </button>
        <button
          type="button"
          class="btn btn--m btn--line btn--gray"
          @click="closeModal"
        >
          닫기
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import FileUpload from "@/component/FileUpload.vue";
import Modal from "@/component/Modal.vue";
import StacksEditor from "@/editor/StacksEditor.vue";
import {
  deepEqual,
  loadFromIndexedDB,
  saveToIndexedDB,
} from "@/views/tempSave/TempSave.js";
import { inject, onMounted, ref, toRaw, watch } from "vue";
import MakrSearchModal from "../../modal/MakrSearchModal.vue";
import reportHandler from "../../ReportHandler.js";
import dc from "@/component/DataChk.js";

export default {
  name: "VulInfo",
  components: { StacksEditor, Modal, MakrSearchModal, FileUpload },
  props: {
    modelValue: { type: Object, required: true },
    edit: { type: Boolean, required: true },
    modReportInfo: { type: Object, default: null },
    rewardNmCodes: { type: Array, default: [] }, // 신고포상제 대분류
    vulAttackTypeCodes: { type: Array, default: [] }, // 공격 유형
    vulEffectCodes: { type: Array, default: [] }, // 영향
    makrSeCdCodes: { type: Array, default: [] }, // 소프트웨어 유형 대분류
  },
  setup(props, { emit, expose }) {
    const lodash = inject("lodash");
    // data 정의
    const reportInfo = ref(lodash.cloneDeep(props.modelValue.reportInfo));
    const uploadFile = ref(props.modelValue.uploadFile);
    const rewardSubNmCodes = ref([]); // 신고포상제 소분류
    const makrSeCdMidCodes = ref([]); // 소프트웨어 유형 중분류
    const makrSeCdSmlCodes = ref([]); // 소프트웨어 유형 소분류
    const allowExt = ref(reportHandler.getAllowAttachFileExt());
    const showRewardExpired = ref(false);
    const isModal = ref(false);
    const showVulFile = ref(false);
    const showVulMethod = ref(false);
    const showVulParam = ref(false);
    const showVulUrl = ref(false);
    const isDirty = ref(false);
    const lastSavedData = ref(null);
    const editorKey = ref(0);
    const EXPIRE_TIME_MS = 60 * 60 * 1000;
    const dbName = "vulReport_db";
    const storeName = "reportStore";
    const delayTime = 800;
    const forcedEntryMakrName = ref();

    // methods 정의
    const addMakrName = () => {
      if (forcedEntryMakrName.value) {
        reportInfo.value.forcedEntryMakrName = forcedEntryMakrName.value;

        reportInfo.value.makrName = "없음";
        reportInfo.value.swNmText = "없음";
        reportInfo.value.makr = "MAKR_CD_1121";
        reportInfo.value.swNm = "MAKR_CD_1122";
      }

      closeModal();
    };
    // 신고포상제 대분류 선택 시 소분류 세팅
    const rewardNmChange = async () => {
      const matched = props.rewardNmCodes.find(
        (i) => i.id === reportInfo.value.rewardNm
      );
      reportInfo.value.rewardNmStr = matched ? matched.rewardNm : "";

      const result = await reportHandler.selectRewardNm(
        reportInfo.value.rewardNm
      );
      if (Array.isArray(result)) {
        rewardSubNmCodes.value = result;
      }
    };

    // 신고포상제 대분류 선택 시 소분류 세팅
    const rewardSubNmChange = async () => {
      const matched = rewardSubNmCodes.value.find(
        (i) => i.id === reportInfo.value.rewardSubNm
      );
      reportInfo.value.rewardSubNmStr = matched ? matched.subNm : "";
    };

    // 소프트웨어 유형 중분류 세팅
    const makrSeCdChange = async () => {
      changeInputDisplay();

      const result = await reportHandler.selectMakrSeCd(
        reportInfo.value.makrSeCd
      );
      if (Array.isArray(result)) {
        makrSeCdMidCodes.value = result;
      }
    };
    // 소프트웨어 유형 소분류 세팅
    const makrSeCdMidChange = async () => {
      const result = await reportHandler.selectMakrSeCdMid(
        reportInfo.value.makrSeCdMid
      );
      if (Array.isArray(result)) {
        makrSeCdSmlCodes.value = result;
      }
    };

    // 소프트웨어 유형 선택 시 input display 변경
    const changeInputDisplay = () => {
      const makrSeCd = reportInfo.value.makrSeCd;

      if (makrSeCd == "MAKR_SE_CD_01") {
        showVulFile.value = true;
        showVulMethod.value = true;
        showVulParam.value = true;
        showVulUrl.value = false;
      } else if (makrSeCd == "MAKR_SE_CD_02") {
        showVulFile.value = true;
        showVulMethod.value = true;
        showVulParam.value = false;
        showVulUrl.value = false;
      } else if (makrSeCd == "MAKR_SE_CD_03") {
        showVulFile.value = false;
        showVulMethod.value = false;
        showVulParam.value = true;
        showVulUrl.value = true;
      } else if (makrSeCd == "MAKR_SE_CD_04") {
        showVulFile.value = true;
        showVulMethod.value = false;
        showVulParam.value = true;
        showVulUrl.value = false;
      } else if (makrSeCd == "MAKR_SE_CD_05") {
        showVulFile.value = true;
        showVulMethod.value = true;
        showVulParam.value = false;
        showVulUrl.value = false;
      } else {
        showVulFile.value = true;
        showVulMethod.value = true;
        showVulParam.value = true;
        showVulUrl.value = true;
      }
    };
    // 소프트웨어 유형 명칭 변경
    const makrSeCdNmChange = (item) => {
      let msg = "one / two / three";
      const one = props.makrSeCdCodes.find((e) => e.cd === item.makrSeCd);
      msg = msg.replace("one", one ? one.cdNm : "-");
      const two = makrSeCdMidCodes.value?.find(
        (e) => e.cd === item.makrSeCdMid
      );
      msg = msg.replace("two", two ? two.cdNm : "-");
      const three = makrSeCdSmlCodes.value?.find(
        (e) => e.cd === item.makrSeCdSml
      );
      msg = msg.replace("three", three ? three.cdNm : "-");
      return msg;
    };
    const handleFileAdd = (addedFiles) => {
      // FileUpload 컴포넌트에서 전달받은 파일 목록 처리
      const file = addedFiles.length > 0 ? addedFiles[0] : null;
      uploadFile.value = file;
    };
    const closeModal = () => {
      isModal.value = false;
    };
    const addMakrInfo = (info) => {
      for (const key in info) {
        reportInfo.value[key] = info[key];
      }
      reportInfo.value.forcedEntryMakrName = "";
      closeModal();
    };
    const vulAttackChange = (attack) => {
      const selectedItem = props.vulAttackTypeCodes.find(
        (item) => item.cd === attack
      );
      if (selectedItem) {
        reportInfo.value.attackDesc = selectedItem.description;
        return selectedItem.cdNm;
      }
    };
    const vulEffectChange = (effect) => {
      const selectedItem = props.vulEffectCodes.find(
        (item) => item.cd === effect
      );
      if (selectedItem) {
        reportInfo.value.effectDesc = selectedItem.description;
        return selectedItem.cdNm;
      }
    };
    const onHtmlChanged = ({ id, html }) => {
      if (id === "vulEnvironment") {
        reportInfo.value.vulEnvironmentHtml = html;
      } else if (id === "vulDetection") {
        reportInfo.value.vulDetectionHtml = html;
      } else if (id === "vulCause") {
        reportInfo.value.vulCauseHtml = html;
      } else if (id === "vulVerify") {
        reportInfo.value.vulVerifyHtml = html;
      } else if (id === "vulScript") {
        reportInfo.value.vulScriptHtml = html;
      } else if (id === "vulAction") {
        reportInfo.value.vulActionHtml = html;
      }
    };
    const handleChange = (type, depth) => {
      if (type === "reward") {
        reportInfo.value.rewardSubNm = "";
        rewardNmChange();
      } else {
        if (depth === 1) {
          reportInfo.value.makrSeCdMid = "";
          reportInfo.value.makrSeCdSml = "";
          makrSeCdMidCodes.value = [];
          makrSeCdSmlCodes.value = [];
          if (reportInfo.value.makrSeCd) {
            makrSeCdChange();
          }
        } else {
          reportInfo.value.makrSeCdSml = "";
          makrSeCdSmlCodes.value = [];
          if (reportInfo.value.makrSeCdMid) {
            makrSeCdMidChange();
          }
        }
      }
    };
    const checkRewardExpired = () => {
      const rewardSubNm = reportInfo.value.rewardSubNm;

      const matchedSubReward = rewardSubNmCodes.value.find(
        (item) => item.id === rewardSubNm
      );

      if (!matchedSubReward) {
        showRewardExpired.value = true;
      } else {
        showRewardExpired.value = false;
      }
    };
    const downloadAttach = () => {
      emit("download", reportInfo.value.id, reportInfo.value.attachNm);
    };

    // IndexedDB에서 데이터 불러오기
    const handleLoadFromIndexedDB = async (options = {}) => {
      await loadFromIndexedDB({
        dbName,
        storeName,
        saveId: reportInfo.value.id || "tempData_" + Date.now(),
        requireIdMatch: options.requireIdMatch,
        confirmMsgFn: (targetData) => {
          return confirm(
            `저장된 데이터를 불러오시겠습니까?\n\n제목: ${
              targetData.vulTitle || "없음"
            }\n저장시간: ${new Date(targetData.savedAt).toLocaleString()}`
          );
        },
        onRestore: (restoredData) => {
          Object.assign(reportInfo.value, restoredData);
          lastSavedData.value = lodash.cloneDeep(reportInfo.value);
          isDirty.value = false;
          editorKey.value += 1;
        },
      });
    };

    // IndexedDB 저장 함수
    const handleSaveToIndexedDB = async (data) => {
      try {
        const saveId = reportInfo.value.id || "tempData_" + Date.now();
        await saveToIndexedDB({
          dbName,
          storeName,
          data: toRaw(data),
          saveId,
          EXPIRE_TIME_MS,
        });
      } catch (e) {
        console.error(e);
      }
    };

    const initCode = () => {
      if (reportInfo.value.rewardNm) {
        rewardNmChange();
      }
      if (reportInfo.value.makrSeCd) {
        makrSeCdChange();
      }
      if (reportInfo.value.makrSeCdMid) {
        makrSeCdMidChange();
      }
    };

    // Debounce 유틸리티 함수
    const debounce = (func, delay) => {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    const debouncedSave = debounce(() => {
      if (!isDirty.value) {
        return;
      }

      const currentData = reportInfo.value;

      // 이전 저장값과 diff 비교
      if (lastSavedData.value && deepEqual(currentData, lastSavedData.value)) {
        return;
      }

      handleSaveToIndexedDB(currentData);

      // 저장 완료 후 상태 업데이트
      lastSavedData.value = lodash.cloneDeep(currentData);
      isDirty.value = false;
    }, delayTime);

    // watch computed 정의
    watch(
      () => props.edit,
      (newVal, oldVal) => {
        if (newVal) {
          checkRewardExpired();
        }
      }
    );

    watch(
      reportInfo,
      (newVal) => {
        isDirty.value = true;
        if (!dc.nullChk(reportInfo.value.id)) {
          debouncedSave();
        }

        emit("update:modelValue", {
          ...props.modelValue,
          reportInfo: newVal,
        });
      },
      { deep: true }
    );

    watch(
      uploadFile,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          uploadFile: newVal,
        });
      },
      { deep: true }
    );

    // life cycle 정의
    onMounted(() => {
      lastSavedData.value = lodash.cloneDeep(reportInfo.value);
      isDirty.value = false;

      //   if (props.edit) {
      //     handleLoadFromIndexedDB();
      //   }

      initCode();
    });

    // 부모에게 공개
    expose({
      handleLoadFromIndexedDB,
    });

    // html에서 사용될 데이터 정의
    return {
      rewardSubNmCodes,
      makrSeCdMidCodes,
      makrSeCdSmlCodes,
      rewardNmChange,
      rewardSubNmChange,
      makrSeCdChange,
      makrSeCdMidChange,
      reportInfo,
      allowExt,
      handleFileAdd,
      showVulFile,
      showVulMethod,
      showVulParam,
      showVulUrl,
      editorKey,
      closeModal,
      isModal,
      vulAttackChange,
      vulEffectChange,
      onHtmlChanged,
      uploadFile,
      handleChange,
      addMakrInfo,
      makrSeCdNmChange,
      showRewardExpired,
      downloadAttach,
      addMakrName,
      forcedEntryMakrName,
    };
  },
};
</script>

<style>
.notice-box__list {
  margin-left: 20px;
  list-style: none;
}
</style>